/**
 * Assessment identity and SQLite-flag helpers shared by the dashboard and
 * student flows. Assessment IDs are the only client-side join key; display
 * names are deliberately excluded because different assessments may share a
 * name.
 */
export function assessmentIdOf(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim();
  }
  return String(
    value.assessment_id ??
    value.assessmentId ??
    value.assessment_type ??
    value.id ??
    ''
  ).trim();
}

export function sameAssessment(left, right) {
  const leftId = assessmentIdOf(left);
  return leftId !== '' && leftId === assessmentIdOf(right);
}

export function isEnabledFlag(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

export function settingIsAssigned(setting) {
  return Boolean(setting?.id) && isEnabledFlag(setting?.is_assigned);
}

/**
 * Catalog ownership is intentionally independent from access codes. Access
 * codes can be rotated and are student-facing credentials; the authenticated
 * database user ID is the stable ownership key written by the server.
 */
export function assessmentOwnerKeyForUser(user) {
  const id = Number.parseInt(user?.id, 10);
  return Number.isInteger(id) && id > 0 ? `user:${id}` : '';
}

export function isUserOwnedAssessment(assessment) {
  return /^user:\d+$/.test(String(assessment?.uploaded_by || '').trim());
}

export function assessmentIsOwnedBy(assessment, user) {
  const ownerKey = assessmentOwnerKeyForUser(user);
  return ownerKey !== '' && String(assessment?.uploaded_by || '').trim() === ownerKey;
}
